import { Injectable } from '@angular/core';
import  * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor() { }

  public exportJsonAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportMultipalJsonAsExcelFile(json: any, excelFileName: string): void {
    var workbook = XLSX.utils.book_new();
    Object.keys(json).forEach((key:string) =>{
      let worksheet = XLSX.utils.json_to_sheet(json[key]);
      XLSX.utils.book_append_sheet(workbook, worksheet, key);
    })
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  // public importExcelFileToJson(file:File): void {
  //   console.log("file is ",file)
  //   let jsonData = XLSX.utils.sheet_to_json(file);
  //   console.log("jsonData ===> ",jsonData)
  // }


  // public async importExcelFileToJson(files:File) {
  //   let workBook: XLSX.WorkBook | null = null;
  //   let jsonData = null;
  //   const reader = new FileReader();
  //   const file = files;
  //   reader.onload = (event) => {
  //     const data = reader.result;
  //     workBook = XLSX.read(data, { type: 'binary' });
  //     jsonData = workBook.SheetNames.reduce((initial:any, name) => {
  //       if (workBook) {
  //         const sheet = workBook.Sheets[name];
  //         initial[name] = XLSX.utils.sheet_to_json(sheet);
  //       }
  //       return initial;
  //     }, {});
  //     console.log("jsonData['data']",jsonData['data'])
  //     return jsonData['data']
  //   }
  //   reader.readAsBinaryString(file);
  // }
  
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  
  public downloadAsExcelFileByURL(path: string, fileName: string): void {
    FileSaver.saveAs(path, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
